<div class="flex flex-column p-a-1 p-a-0-s">
    <span class="s1">Our US website is currently unavailable, and shipping to all US addresses is temporarily restricted
        from our UK and IE websites.</span>
    <div class="center m-t">
        <button class="w-12 m-b-3-s button"
                (click)="close()">
            <span>Close</span>
        </button>
    </div>
</div>
